import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { PlatformService } from './platform.service';
import { langsSupported } from '../enums/languages';
declare let adsbygoogle: any;

@Injectable({ providedIn: 'root' })
export class DocumentService {
  get currentPath() {
    return this.document.location.pathname;
  }
  get location() {
    return this.document.location;
  }

  get window() {
    return this.document.defaultView as Window | any;
  }

  // get i18nPageName() {
  //   let pageName = this.document.location.pathname
  //     .split('/')
  //     .filter((path) => !langsSupported.some((lang) => lang == path))[1];
  //   // console.log('pageName', pageName);
  //   // console.log(
  //   //   'this.document.location.pathname',
  //   //   this.document?.location?.pathname,
  //   // );

  //   if (this.document.location.pathname == '/' || pageName == '') {
  //     pageName = 'home';
  //   } else if (
  //     pageName &&
  //     (pageName.startsWith('qr_') || pageName.startsWith('_'))
  //   ) {
  //     pageName = 'landing-post';
  //   }

  //   return pageName;
  // }

  // onScroll = new EventEmitter();
  constructor(
    @Inject(DOCUMENT) public document: Document,
    private pt: PlatformService,
  ) {
    //this.handleScroll();
  }
  reload() {
    this.location.reload();
  }
  scrollToElement(tagName: string) {
    //  if (!this.pt.isMobile) return;
    setTimeout(() => {
      const element = this.document.getElementsByTagName(tagName)[0];
      if (element && typeof element.scrollIntoView == "function") {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }, 50);
  }

  // handleScroll() {
  //   this.document.addEventListener('scroll', () => {
  //     this.onScroll.emit();
  //   });
  // }

  onFirstScroll() {
    return new Promise<any>((resolve) => {
      this.document.addEventListener('scroll', () => {
        resolve(null);
      });
    });
  }

  injectAdsenseScript() {
    this.document.getElementById('adsenseScript')?.remove();
    setTimeout(() => {
      var scriptTag = this.document.createElement('script');
      scriptTag.id = 'adsenseScript';
      scriptTag.type = 'text/javascript';
      scriptTag.async = true;
      scriptTag.defer = true;
      scriptTag.crossOrigin = 'anonymous';
      scriptTag.src =
        'https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js';
      var firstScript = this.document.getElementsByTagName('script')[0];
      firstScript?.parentNode?.insertBefore(scriptTag, firstScript);
    }, 0);
  }

  injectGTagScript() {
    (this.document.defaultView as any)['dataLayer'] =
      (this.document.defaultView as any)['dataLayer'] || [];

    (this.document.defaultView as any)['dataLayer'].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });

    const scriptTag = this.document.createElement('script');
    scriptTag.async = true;
    scriptTag.defer = true;
    scriptTag.src = `https://www.googletagmanager.com/gtm.js?id=GTM-WK26TV8Z&l=dataLayer`;

    var firstScript = this.document.getElementsByTagName('script')[0];
    firstScript?.parentNode?.insertBefore(scriptTag, firstScript);
  }

  goTop() {
    if (!this.pt.isServer)
      this.window.scrollTo({ top: 0, behavior: 'smooth' });
  }

  bindCulrutrInfo(dir: string, language: string) {
    this.document.documentElement.dir = dir;
    this.document.documentElement.lang = language as any;
  }

  injectARFont() {
    this.document.head.insertAdjacentHTML("afterbegin", `
  <!-- Preload Cairo font -->
  <link rel="preload" as="style"
    href="https://fonts.googleapis.com/css2?family=Cairo:slnt,wght@-11..11,200..1000&display=swap">
  <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Cairo:slnt,wght@-11..11,200..1000&display=swap"
    media="all" onload="this.onload=null;this.rel='stylesheet';">
  `)
  }

  injectENFont() {
    this.document.head.insertAdjacentHTML("afterbegin", `
        <!-- Preload Poppins font -->
      <link rel="preload" as="style"
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap">
      <link rel="stylesheet"
        href="https://fonts.googleapis.com/css2?family=Poppins:wght@100;200;300;400;500;600;700;800;900&display=swap"
        media="all" onload="this.onload=null;this.rel='stylesheet';">
    
           `)
  }
}
